import ITagPedagioRepository from '../repositories/ITagPedagioRepository'

export interface IFindActiveTag {
  execute(cpf_motorista: string): Promise<string>
}

export default class FindActiveTagImpl implements IFindActiveTag {
  constructor(private readonly tagPedagioRepository: ITagPedagioRepository) {}

  public async execute(cpf_motorista: string): Promise<string> {
    const response = await this.tagPedagioRepository.findActiveTag(
      cpf_motorista,
    )
    return response
  }
}
